import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import BookingsService from '../../services/bookings.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import ServiceRestServices from "../../services/service-rest.service";

@Component({
    standalone: true,
    selector: 'modal-booking-address',
    templateUrl: './modal-booking-address.component.html',
    imports: [ CommonModule, TranslatePipe, ItemErrorComponent, FormsModule ]
})
export class ModalBookingAddressComponent implements OnInit {
    private bookingsService: BookingsService = inject(BookingsService);
    private angularHelperService: AngularHelperService = inject(AngularHelperService);
    private dialogRef = inject(MatDialogRef<ModalBookingAddressComponent>);
    private data = inject(MAT_DIALOG_DATA);
    private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);

        this.vm.booking = this.angularHelperService.copy(this.vm.booking) || {};
        this.vm.booking.service = this.vm.booking.service || {};
        this.vm.uid = 'mba-' + Date.now();

        this.vm.handleModalClose = this.handleModalClose;
        this.vm.handleAddressFormSubmit = this.handleAddressFormSubmit;
    }

    handleAddressFormSubmit(addressForm: any) {
        this.vm.submitted = true;
        if (addressForm.invalid) return;

        this.serviceRestServices.updateOfficeAddress({bookingId: this.vm.booking.id, address: this.vm.booking.service.officeAddress})
            .then(() => {
                this.dialogRef.close(this.vm.booking.service.officeAddress);
            })
            .catch(err => {
                console.error('Failed to save address', err);
            });
    }

    handleModalClose() {
        this.dialogRef.close();
    }
}
